import { render } from "./AdSection3.vue?vue&type=template&id=19228664&scoped=true"
import script from "./AdSection3.vue?vue&type=script&lang=js"
export * from "./AdSection3.vue?vue&type=script&lang=js"

import "./AdSection3.vue?vue&type=style&index=0&id=19228664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19228664"]])

export default __exports__